export default class Provider {
  public static readonly GET_PAYMENT_STATUS = '/provider/{rank}/{license}/payment/status';
  public static readonly SEARCH_PAYMENT_STATUS = '/provider/payment/status';
}
